import { basic, initTopbar } from './modules/layouts';
import { initLocaleDatetime, loadImg } from './modules/components';

loadImg();
initLocaleDatetime();
initTopbar();
basic();
